import { Action, Dispatch } from 'redux'
import { FirebaseDocRefType } from 'firebase/index'
import { StoreDeliveryBreadType } from 'types/storeDeliveryBread'
import { fetchStoreDeliveryBreadAction } from 'reducks/storeDeliveryBread/actions'

const fetchStoreDeliveryBread = (storeRef: FirebaseDocRefType, breadRef: FirebaseDocRefType) => {
  return async (dispatch: Dispatch<Action>) => {
    return storeRef
      .collection('store_delivery_breads')
      .where('bread_ref', '==', breadRef)
      .get()
      .then((snapshots) => {
        const snapshot = snapshots.docs[0]
        if (!snapshot) return
        const data = snapshot.data() as StoreDeliveryBreadType
        data.ref = snapshot.ref
        dispatch(fetchStoreDeliveryBreadAction(data))
      })
      .catch((error: unknown) => {
        console.error(error)
      })
  }
}

export default fetchStoreDeliveryBread
